module.exports = __webpack_public_path__ + "img/collection-diamondJewelryEarrings.cffaba4.jpg";